import { createAction } from '@src/redux/helpers/createAction';
import { SET_CURRENT_FLOW } from './constants';

export const setCurrentFlow = (payload) => {
  return createAction({
    type: SET_CURRENT_FLOW,
    payload,
  });
};
